























































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import ReservationDetailState from "@/store/reservation/state";
import InputNumber from "@/components/common/input/InputNumber.vue";
import TireDialog from "@/components/tireDialog.vue";
import InputCode from "@/components/common/input/InputCode.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
// import EstimateSubHeader from "@/components/EstimateSubHeader.vue";
import { MESSAGE } from "@/model/Message";
import { CustomerService } from "@/service/CustomerService";
import { ElButton } from "element-ui/types/button";
import Number from "@/shared/filters/Number";
import { KbnSkn } from "@/model/KbnSkn";
import { CarSelectData } from "@/model/CarSelection";
import { Utils } from "@/service/util";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { InspectService } from "@/service/inspectService";
import { IppanSeibiService } from "@/service/IppanSeibiService";

const namespace: string = "ReservationDetail";
@Component({
  components: {
    InputNumber,
    ConfirmDialog,
    InputCode,
  //  EstimateSubHeader
  //  InputCode,
  //  SaveDialog,
    TireDialog
  //  , CarSelection
  },
  filters: {
    Number
  }
})


export default class InspectListMain extends Vue {
  // @Prop()  eluiList: any = [];
  @Prop({ default: false }) isModeQuick: boolean;
  // @Prop() btncolor: string = "";
  // @Prop() kbnSkns: KbnSkn[][] = [[], [], [], [], [], [], []];
  // @Prop() carForm: CarSelectData = {} as CarSelectData;

  @Prop({ default: () => {} }) carFormQuickInfo: CarSelectQuickInfoData;


  @Action("updateSoukouKm", { namespace })
  updateSoukouKm: any;
  @Action("updateSoukouKmAvg", { namespace })
  updateSoukouKmAvg: any;
  @Action("updateSoukouMile", { namespace })
  updateSoukouMile: any;

  @Action("updateSoukou", { namespace: "CarSelection" })
  updateSoukouMD3: any;

  @Action("updateSoukouMile", { namespace: "CarSelection" })
  updateSoukouMileMD3: any;
// ここは必要
  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  public reqService: requestService = new requestService();

  // クイックの動作に必要
  setFormQuickInfo(props: string, params: any) {
    this.$emit("setFormQuickInfo", props , params );
  }
  
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "CarSelection" })
  currentState: CarSelectData;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setState", { namespace: "CarSelection" })
  setState: any;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Action("updateMakerModel", { namespace: "ReservationDetail" })
  updateMakerModel: any;

  @Action("updateSoukouUnitKbn", { namespace: "CarSelection" })
  updateSoukouUnitKbn: any;
  @Action("updateSoukouBikouKbn", { namespace: "CarSelection" })
  updateSoukouBikouKbn: any;
  @Action("updateSoukouUnitKbn", { namespace: "ReservationDetail" })
  updateSoukouUnitKbnMD1: any;
  @Action("updateSoukouBikouKbn", { namespace: "ReservationDetail" })
  updateSoukouBikouKbnMD1: any;

  @Getter("isLaurelCustom", { namespace: "FunctionSetting" })
  isLaurelCustom: boolean | null; // システム設定C ローレル要望

//  public reqService: requestService = new requestService();// 宣言済み
  inspectService: InspectService = new InspectService();
  ippanSeibiService: IppanSeibiService = new IppanSeibiService();
  public utils: Utils = new Utils();
  kbnTitles: string[] = [
    "skn_youto",
    "skn_kudou_houshiki",
    "skn_fuel_kbn",
    "skn_shift_kbn",
    "skn_meter_panel_alert",
    "skn_brake",
    "skn_saitei_chijou_kou_kbn"
  ];
  eluiList: any = [];
  kbnSkns: KbnSkn[][] = [[], [], [], [], [], [], []];
  isUserMode: boolean = false;
  kbnJidousha: any = [];
  errorMsg: string = "";
  listKakyuki: any = [];
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  shashuRenban: any = null;
  saveType: string = "";
  maker: string = "";
  model: string = "";
  customerService: CustomerService = new CustomerService();
  msgNodata: string = MESSAGE.NoData;
  msgBelowLastSoukou: string = MESSAGE.BelowLastSoukou;
  carForm: CarSelectData = {} as CarSelectData;
  soukouBikouList: any = [];
  soukouUnitList: any = [];
  soukouUnitKbn: number | null = null;
  soukouBikouKbn: number | null = null;
  soukouMile: number = 0;
  soukouKm: number = 0;
  originalSoukouKm: number | null = 0;
  originalSoukouMile: number | null = 0;
  isExceed: boolean = false;
  tempKm: any = null;
  tempMile: any = null;
  tireForm: any = {};
  title: string = "";
  nyuukoErrorMsg: string = "";
  
  
  
  $refs!: {
//    btnRigister: ElButton;
//    btnBrake: ElButton[];
    errorDialog: ConfirmDialog;
//    saveDialog: SaveDialog;
    inputSoukouKm: InputNumber;
//    cancelDialog: ConfirmDialog;
    tireDialog: TireDialog;
//    nyuukoErrorDialog: ConfirmDialog;
  };

  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
      // if ( this.isNextageCustom ) {
    } else {
    }

    if (this.isModeQuick) {
      // if (this.isUserMode) {
      //  
      // }
      this.eluiList = [2,3,4,6,7,8,9,10,11,12,13,14,15,16];// ダミー
    } else {
      if (this.isUserMode) {
        this.eluiList = [2,3,4,6,7,8,9,10,11,12,13,14,15,16];
      } else {
        this.eluiList = [2,3,4,6,7,8,9,10,11,12,13,14,15,16];// ダミー
      }
    }
    this.$emit("onactivepage", this.$route.name);
    let kbn1 = this.reqService.getSoukouBikou().then(list => {
      this.soukouBikouList = list;
    //  this.setSoukouData();
    });
    let kbn2 = this.reqService.getSoukouUnit().then(list => {
      this.soukouUnitList = list;
    //  this.setSoukouData();
    });
    Promise.all([kbn1, kbn2]).then(() => this.setSoukouData());
    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);// ここでは使ってない
        }
      },
      (err: any) => {}
    );

    let promise = this.kbnTitles.map(async (kbn: string) => {
      return this.reqService.getKbnSkns(kbn);
    });
    Promise.all(promise).then((res: any) => {
      this.$set(this, "kbnSkns", res);
      this.getData(); // こっちでやった方がいい
    });
    // 不要this.getNyuukoInfo();
  }




  get uketsuke() {
    if (this.reservationState) {
      return this.reservationState.uketsuke;
    }
    return {};
  }

  get srMakerCd() {
    if (this.uketsuke && this.uketsuke.srMakerCd) {
      return this.uketsuke.srMakerCd;
    }
    return "";
  }

  get srModelCd() {
    if (this.uketsuke.srModelCd) {
      return this.uketsuke.srModelCd;
    }
    return "";
  }

  get srMakerNm() {
    if (this.uketsuke.srMakerNm) {
      return this.uketsuke.srMakerNm;
    }
    return "";
  }

  get srModelNm() {
    if (this.uketsuke.srModelNm) {
      return this.uketsuke.srModelNm;
    }
    return "";
  }

  // ローレルかつ一般整備の場合は、前タイヤ・後ろタイヤを無効化
  get isTireDisabled() {
    return this.isLaurelCustom && this.ippanSeibiService.isIppanSeibi;
  }

  async setSoukouData() {
    if (this.currentState.soukouBikouKbn) {
      this.carForm.soukouBikouKbn = +this.currentState.soukouBikouKbn;
    } else {
      this.carForm.soukouBikouKbn = +this.soukouBikouList[0].kbn;
    }
    if (this.currentState.soukouUnitKbn) {
      this.carForm.soukouUnitKbn = +this.currentState.soukouUnitKbn;
    } else {
      this.carForm.soukouUnitKbn = +this.soukouUnitList[0].kbn;
    }
    this.updateSoukouUnitKbn(this.carForm.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.carForm.soukouBikouKbn);
    this.updateSoukouUnitKbnMD1(this.carForm.soukouUnitKbn);
    this.updateSoukouBikouKbnMD1(this.carForm.soukouBikouKbn);
    try {
      if (this.carForm.soukouKm && !this.carForm.soukouMile) {
        await this.onFocusoutSoukouKm();
      } else if (this.carForm.soukouMile && !this.carForm.soukouKm) {
        await this.onFocusoutSoukouMile();
      }
    } catch (e) {
      console.log("error: cannot convert soukou");
    }
  }
  
  async convertMilesKm(soukou: number, soukouUnitKbn: number) {
    // const soukouUnitKbn = this.soukouUnitKbn || 1;
    let soukouConv: any = await this.reqService.convertMiles_Km(
      soukou,
      soukouUnitKbn.toString()
    );
    if (soukouUnitKbn === 2) {
      this.soukouKm = soukouConv.km;
      this.soukouMile = soukou;
    } else {
      this.soukouKm = soukou;
      this.soukouMile = soukouConv.miles;
    }
    this.updateSoukouKm(this.soukouKm);
    this.updateSoukouMD3(this.soukouKm);
    this.updateSoukouMile(this.soukouMile);
    this.updateSoukouMileMD3(this.soukouMile);
  }

  saveTempSoukou() {
    this.tempKm = this.soukouKm;
    this.tempMile = this.soukouMile;
  }

  onExceedSoukou() {
    this.errorMsg = this.utils.msgExceedSoukou(this.soukouUnitKbn);
    this.$refs.errorDialog.onOpen();
  }

  onCloseMsg() {
    if (this.isExceed) {
      this.isExceed = false;
      this.$set(this, "soukouKm", this.tempKm);
      this.$set(this, "soukouMile", this.tempMile);
    }
  }

  onFocusoutSoukouKm() {
    const tempKm: number = this.carForm.soukouKm ? +this.carForm.soukouKm : 0;
    this.isExceed = this.utils.checkLimitSoukou(tempKm, this.carForm.soukouUnitKbn);
    if (this.isExceed) {
      this.onExceedSoukou();
    } else {
      if (tempKm) {
        let extend = this.reservationState.sknUketsukeExtends;
        if (extend.zenkaiSoukouKm && tempKm && tempKm < extend.zenkaiSoukouKm) {
          this.onZenkaiSoukouWarning();
        }
        this.reqService.convertMiles_Km(tempKm, "1").then((mile: any) => {
          if (mile) {
            this.carForm.soukouMile = mile.miles ? mile.miles : 0;
            this.saveTempSoukou();
          }
        });
      } else {
        this.carForm.soukouMile = 0;
      }
    }
  }

  onFocusoutSoukouMile() {
    const tempMile: number = this.carForm.soukouMile
      ? +this.carForm.soukouMile
      : 0;
    this.isExceed = this.utils.checkLimitSoukou(tempMile, this.carForm.soukouUnitKbn);
    if (this.isExceed) {
      this.onExceedSoukou();
    } else {
      if (tempMile) {
        let extend = this.reservationState.sknUketsukeExtends;
        if (extend.zenkaiSoukouMile && tempMile && tempMile < extend.zenkaiSoukouMile) {
          this.onZenkaiSoukouWarning();
        }
        this.reqService.convertMiles_Km(tempMile, "2").then((km: any) => {
          if (km) {
            this.carForm.soukouKm = km.km ? km.km : 0;
            this.saveTempSoukou();
          }
        });
      } else {
        this.carForm.soukouKm = 0;
      }
    }
  }
  
  get convertElUiLayout() {
    let list: any = new Array();
    let sub: any = new Array();
    for ( let i = 0; i < this.eluiList.length ; i++ ) {
      sub[i%2] = this.eluiList[i];
      if ( i % 2 == 0 ) { list[i/2] = new Array(); }
      list[i/2] = sub;
      if ( i % 2 == 2 -1 ) { sub = []; }
    }
    return list;
  }

  public setForm(props: string, params: any) {
    // ボタンの動作を一部無効化
    if (this.isModeQuick||!this.isUserMode) {
      this.carForm[props] = (params == this.carForm[props]
        ? ""
        : +params
      ).toString();
      if (props === "shiftKbn" && !this.carForm.shiftKbn) {
        this.carForm.shiftKbn = this.kbnSkns[3][0].kbnKey;
      }
      if (props === "kudouHoushiki" && !this.carForm.kudouHoushiki) {
        this.carForm.kudouHoushiki = this.kbnSkns[1][0].kbnKey.toString();
      }
      this.setState(this.carForm);
    }
  }

  activeBtn( judge: boolean ) {
    
    if (judge) {
      if ( !this.isModeQuick && this.isUserMode ) {
        return 'red-active'; 
      } else {
        return 'orange-active'; // 通常色
      }
    } else {
      return '';
    }
  }

  getData() {
    this.reqService
      .getCarSelection(this.uketsukeExtendsId)
      .then(
        (res: any) => {
          res.sknUketsukeExtendsId = this.uketsukeExtendsId;
          this.setState({ ...res, uketsukeCd: this.uketsukeCd });
          this.carForm = this.currentState;
          this.saveTempSoukou();
          this.setOriginalSoukou();
          this.setDefaultBtn();
          this.shashuRenban = this.carForm.shashuRenban;
          this.setProgressState({
            stateId: res.sknWorkProgressState,
            stateNm: res.sknWorkProgressStateNm
          });
        },
        (err: any) => {
          console.log(err);
        }
      )
      .catch(error => {
        console.log(error);
      });
  }

  

  setOriginalSoukou() {
    const { soukouKm = 0, soukouMile = 0 } = this.carForm;
    this.originalSoukouKm = soukouKm;
    this.originalSoukouMile = soukouMile;
  }

  setDefaultBtn() {
    // set default button value in carForm variable
    if (!this.carForm.shiftKbn) {
      this.carForm.shiftKbn = this.kbnSkns[3][0].kbnKey;
    }
    if (!this.carForm.kudouHoushiki) {
      this.carForm.kudouHoushiki = this.kbnSkns[1][0].kbnKey.toString();
    }
  }
  
  activeKudouHoushiki(kbn: KbnSkn) {
    if (!this.carForm.kudouHoushiki) {
      return kbn.num == 1;
    } else {
      return +this.carForm.kudouHoushiki == kbn.kbnKey;
    }
  }

  activeShift(kbn: KbnSkn) {
    if (!this.carForm.shiftKbn) {
      return kbn.num == 1;
    } else {
      return +this.carForm.shiftKbn == kbn.kbnKey;
    }
  }

  onFocusout() {
    this.setState(this.carForm);
  }

  onFocusoutKatashiki() {
    // this.clearShashu();
    this.onFocusout();
  }

  get checkFTire() {
    if (
      this.carForm.fTireSizeWize &&
      (this.carForm.fTireSizeHenpei || this.carForm.fTireSizeSpeed) &&
      this.carForm.fTireSizeInchi &&
      (this.carForm.fTireSizeIndex || this.carForm.youto != 3)
    ) {
      return true;
    }
    return false;
  }
  

  setRTireFromFTire() {
    this.carForm.rTireSizeWize = this.carForm.fTireSizeWize;
    this.carForm.rTireSizeHenpei = this.carForm.fTireSizeHenpei;
    this.carForm.rTireSizeInchi = this.carForm.fTireSizeInchi;
    this.carForm.rTireSizeIndex = this.carForm.fTireSizeIndex;
    this.carForm.rTireSizePlyRating = this.carForm.fTireSizePlyRating;
    this.carForm.rTireSizeRadial = this.carForm.fTireSizeRadial;
    this.carForm.rTireSizeSpeed = this.carForm.fTireSizeSpeed;
    this.$set(this.carForm, "rTireSizeInput", this.carForm.fTireSizeInput);
  }

  onEnterSoukoukm() {
    this.$refs.inputSoukouKm.blur();
  }

  get showToolTip() {
    if (this.reservationState && this.reservationState.sknUketsukeExtends) {
      let extend = this.reservationState.sknUketsukeExtends;
    }
    return false;
  }

  changeSoukouUnit() {
    this.updateSoukouUnitKbn(this.carForm.soukouUnitKbn);
    this.updateSoukouUnitKbnMD1(this.carForm.soukouUnitKbn);
    this.reqService.saveMileage( // sendSocket:ソケット仮23
      this.customerService.getPutParams({
        soukouKm: this.originalSoukouKm,
        soukouMile: this.originalSoukouMile,
        soukouUnitKbn: this.carForm.soukouUnitKbn,
        soukouBikouKbn: this.carForm.soukouBikouKbn
      })
    );
  }

  changeSoukouBikou() {
    this.updateSoukouBikouKbn(this.carForm.soukouBikouKbn);
    this.updateSoukouBikouKbnMD1(this.carForm.soukouBikouKbn);
    this.reqService.saveMileage( // sendSocket:ソケット仮23
      this.customerService.getPutParams({
        soukouKm: this.originalSoukouKm,
        soukouMile: this.originalSoukouMile,
        soukouUnitKbn: this.carForm.soukouUnitKbn,
        soukouBikouKbn: this.carForm.soukouBikouKbn
      })
    );
  }

  clickHibi(val: number, index: number) {
    this.inspectService.resetHibi(val, index, this.carForm);
  }

  onInputFLeftTire(e: any) {
    console.log("onInputFLeftTire => ", e);
    this.carForm.fRightTireNokorimizo = this.carForm.fLeftTireNokorimizo;
  }

  onInputRLeftTire() {
    this.carForm.rRightTireNokorimizo = this.carForm.rLeftTireNokorimizo;
  }

  beforeDestroy() {
  //  this.carForm.soukouKm = this.originalSoukouKm;
  //  this.carForm.soukouMile = this.originalSoukouMile;
  }
  
  showTireDialog(isFront: boolean) {
    if (isFront) {
      this.tireForm = {
        isFront: isFront,
        wize: this.carForm.fTireSizeWize,
        henpei: this.carForm.fTireSizeHenpei
          ? this.carForm.fTireSizeHenpei
          : this.carForm.fTireSizeSpeed,
        radial: this.carForm.fTireSizeRadial,
        inchi: this.carForm.fTireSizeInchi,
        index: this.carForm.fTireSizeIndex,
        plyRating: this.carForm.fTireSizePlyRating,
        isKamotsu: this.carForm.youto == 3 ? true : false
      };
    } else {
      this.tireForm = {
        isFront: isFront,
        wize: this.carForm.rTireSizeWize,
        henpei: this.carForm.rTireSizeHenpei
          ? this.carForm.rTireSizeHenpei
          : this.carForm.rTireSizeSpeed,
        radial: this.carForm.rTireSizeRadial,
        inchi: this.carForm.rTireSizeInchi,
        index: this.carForm.rTireSizeIndex,
        plyRating: this.carForm.rTireSizePlyRating,
        isWTire: this.carForm.isWideTire,
        isKamotsu: this.carForm.youto == 3 ? true : false
      };
    }
    this.$refs.tireDialog.onOpen(this.tireForm);
  }
/*
 * // 2次必要
 *   setTireFrom(param: any) {
 *     if (this.tireForm.isFront) {
 *       this.carForm.fTireSizeWize = param.wize;
 *       this.carForm.fTireSizeRadial = param.radial;
 *       this.carForm.fTireSizeInchi = param.inchi;
 *       this.carForm.fTireSizeIndex = param.index;
 *       this.carForm.fTireSizePlyRating = param.plyRating;
 *       if (param.henpei === "S") {
 *         this.carForm.fTireSizeHenpei = null;
 *         this.carForm.fTireSizeSpeed = param.henpei;
 *       } else {
 *         this.carForm.fTireSizeHenpei = param.henpei;
 *         this.carForm.fTireSizeSpeed = null;
 *       }
 *       let fTireSizeInput = this.setTireSizeInput(param);
 *       this.$set(this.carForm, "fTireSizeInput", fTireSizeInput);
 *     } else {
 *       this.carForm.rTireSizeWize = param.wize;
 *       this.carForm.rTireSizeRadial = param.radial;
 *       this.carForm.rTireSizeInchi = param.inchi;
 *       this.carForm.rTireSizeIndex = param.index;
 *       this.carForm.rTireSizePlyRating = param.plyRating;
 *       if (param.henpei === "S") {
 *         this.carForm.rTireSizeHenpei = null;
 *         this.carForm.rTireSizeSpeed = param.henpei;
 *       } else {
 *         this.carForm.rTireSizeHenpei = param.henpei;
 *         this.carForm.rTireSizeSpeed = null;
 *       }
 *       this.carForm.isWideTire = param.isWTire;
 *       let rTireSizeInput = this.setTireSizeInput(param);
 *       this.$set(this.carForm, "rTireSizeInput", rTireSizeInput);
 *     }
 *   }
 * 
 * // 2次必要
 *   setTireSizeInput(param: any): string {
 *     let str = "";
 *     if (param.radial === "R") {
 *       if (param.henpei === "S") {
 *         // 165SR14
 *         str =
 *           (param.wize ? param.wize.toString() : "") +
 *           (param.henpei ? param.henpei.toString() : "") +
 *           param.radial +
 *           param.inchi;
 *       }
 *       // 幅/扁平率,ラジアル,リム径 ex)185/55R16
 *       str =
 *         (param.wize ? param.wize.toString() : "") +
 *         "/" +
 *         (param.henpei ? param.henpei.toString() : "") +
 *         "/" +
 *         param.radial +
 *         param.inchi;
 *     } else {
 *       // バイアスタイヤ ex)5.60-13 4PR
 *       str = (param.wize ? param.wize.toString() : "") + "-" + param.inchi;
 *     }
 *     if (param.index && this.carForm.youto == 3)
 *       str += " " + param.index + param.plyRating;
 *     return str;
 *   }
  */

  setTireSize(isFront: boolean) {
    let val = "";
    if (isFront) {
      val = this.carForm.fTireSizeInput ? this.carForm.fTireSizeInput : "";
    } else {
      val = this.carForm.rTireSizeInput ? this.carForm.rTireSizeInput : "";
    }
    if (val != "") {
      this.reqService.getTireSize(val).then(
        (res: any) => {
          if (res) {
            if (isFront) {
              this.carForm.fTireSizeWize = res.wize ? Number(res.wize) : null;
              this.carForm.fTireSizeHenpei = res.henpei
                ? Number(res.henpei)
                : null;
              this.carForm.fTireSizeInchi = res.inchi
                ? Number(res.inchi)
                : null;
              this.carForm.fTireSizeIndex = res.index
                ? Number(res.index)
                : null;
              this.carForm.fTireSizeRadial = res.radial;
              this.carForm.fTireSizeSpeed = res.speed;
              this.carForm.fTireSizePlyRating = res.plyRating;
            } else {
              this.carForm.rTireSizeWize = res.wize ? Number(res.wize) : null;
              this.carForm.rTireSizeHenpei = res.henpei
                ? Number(res.henpei)
                : null;
              this.carForm.rTireSizeInchi = res.inchi
                ? Number(res.inchi)
                : null;
              this.carForm.rTireSizeIndex = res.index
                ? Number(res.index)
                : null;
              this.carForm.rTireSizeRadial = res.radial;
              this.carForm.rTireSizeSpeed = res.speed;
              this.carForm.rTireSizePlyRating = res.plyRating;
            }
          }
        },
        (err: any) => {}
      );
    }
  }

  revertTireSize(isFront: boolean) {
    let data = {
      ...this.carForm,
      uketsukeCd: this.uketsukeCd,
      isFront: isFront.toString()
    };
    this.reqService.revertTireSize(data).then(
      (res: any) => {
        if (res.status != 204) {
          if (isFront) {
            this.$set(this.carForm, "fTireSizeInput", res.bodyText.toString());
          } else {
            this.$set(this.carForm, "rTireSizeInput", res.bodyText.toString());
          }
        }
      },
      (err: any) => {}
    );
  }

  onZenkaiSoukouWarning() {
    this.errorMsg = '前回走行距離よりも少ない数値が入力されました。問題なければこのまま進めてください。';
    this.$refs.errorDialog.onOpen();
  }

}
